"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CircularProgress2 = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Divider2 = _interopRequireDefault(require("@mui/material/Divider"));
var _Button3 = _interopRequireDefault(require("@mui/material/Button"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _findIllus = _interopRequireDefault(require("../../../assets/images/find-illus.svg"));
var _fakeEmployees = _interopRequireDefault(require("../individual-leaderboard/fake-employees"));
var _header = _interopRequireDefault(require("../individual-leaderboard/header"));
var _item = _interopRequireDefault(require("../individual-leaderboard/item"));
var _rankCard = _interopRequireDefault(require("../individual-leaderboard/rank-card"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function IndividualLeaderboard({
  Button: _Button,
  FakeItemsCard,
  isFree,
  event,
  freeOfferEmployeesLeaderboardsMaxRowsCount,
  page,
  leaderboard,
  count,
  userChallenge,
  loading,
  setPage
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const Button = _Button || _Button3.default;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !leaderboard || leaderboard.length > 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_rankCard.default, {
    challengeTemplate: event.challengeTemplate,
    numberOfParticipants: count,
    progress: userChallenge
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    border: "1px solid #dde0e7",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_header.default, {
    event: event
  }), leaderboard ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, leaderboard.map(({
    id,
    leaderboardIndex,
    rank,
    progressValue,
    profilePicture,
    username
  }, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: id
  }, /*#__PURE__*/_react.default.createElement(_Divider2.default, {
    sx: {
      borderColor: '#dde0e7'
    }
  }), /*#__PURE__*/_react.default.createElement(_item.default, {
    challengeType: event.challengeTemplate?.type,
    item: {
      user: id ? {
        id,
        profilePicture,
        username: username || ''
      } : null,
      leaderboardIndex,
      rank,
      progressValue
    },
    prevItemRank: index > 0 ? leaderboard[index - 1].rank : null
  }))), isFree && count && count > freeOfferEmployeesLeaderboardsMaxRowsCount && /*#__PURE__*/_react.default.createElement(_fakeEmployees.default, {
    event: event,
    FakeItemsCard: FakeItemsCard,
    freeOfferEmployeesLeaderboardsMaxRowsCount: freeOfferEmployeesLeaderboardsMaxRowsCount
  })) : new Array(10).fill(null).map((_, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: index
  }, /*#__PURE__*/_react.default.createElement(_Divider2.default, {
    sx: {
      borderColor: '#dde0e7'
    }
  }), /*#__PURE__*/_react.default.createElement(_item.default, {
    challengeType: event.challengeTemplate?.type,
    prevItemRank: null
  }))))) : /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 3,
    paddingY: 5
  }, /*#__PURE__*/_react.default.createElement("img", {
    height: 64,
    src: _findIllus.default
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    fontWeight: 700
  }, t('commons.challenges.leaderboard.empty_state_title_company')), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    variant: "body2"
  }, t('commons.challenges.leaderboard.empty_state_description')))), !isFree && leaderboard && count && count > leaderboard.length ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    disabled: loading,
    endIcon: loading && /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
      color: "inherit",
      size: 16,
      thickness: 4
    }),
    onClick: () => setPage(page + 1),
    size: "small",
    variant: "outlined"
  }, t('commons.actions.see_more'))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
}
var _default = exports.default = IndividualLeaderboard;